module.exports = __webpack_public_path__ + "img/email-open.82ee386c.svg";